import {Component, Host, Input, OnDestroy, OnInit, Optional} from '@angular/core';
import {Subject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

import {OsmService} from '../osm.service';
import {OsmMapComponent} from '../osm-map/osm-map.component';


@Component({
    selector: 'osm-semicircle-combined',
    templateUrl: './osm-semicircle-combined.component.html',
    styleUrls: [
        './osm-semicircle-combined.component.scss'
    ],
    standalone: false
})
export class OsmSemicircleCombinedComponent implements OnInit, OnDestroy {

  private readonly angles = {
    '1': [-22.5, 22.5],
    '2': [22.5, 67.5],
    '3': [67.5, 112.5],
    '4': [112.5, 157.5],
    '5': [157.5, 202.5],
    '6': [202.5, 247.5],
    '7': [247.5, 292.5],
    '8': [292.5, 337.49]
  };

  @Input() public iMap: OsmMapComponent = null;

  private ngDestroy$ = new Subject<boolean>();
  private L;
  private _data;
  private _point;
  private mapSubscribe: Subscription;
  public semicircle;

  get data() {
    return this._data;
  }

  @Input() set data(value) {
    this._data = value;

    if (this.L && this.map) {
      this.whenMapReady();
    }
  }

  public get map() {
    return this.iMap || this.pMap;
  }

  public get point() {
    return this._point;
  }

  @Input() public set point(value) {
    this._point = value;
  }

  private static eq(a, b) {
    return a === -22.5 && b === 337.49 ||
           a === 337.49 && b === -22.5 ||
           a === b;
  }

  constructor(private o: OsmService,
              @Optional() @Host() private pMap: OsmMapComponent) { }

  ngOnInit(): void {
    this.mapSubscribe = this.o.$getMap
      .pipe(takeUntil(this.ngDestroy$))
      .subscribe((L) => {
        if (!L) { return; }

        this.L = L;
        this.map.ready.then(_ => this.whenMapReady());

      });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next(false);
    this.ngDestroy$.unsubscribe();
    if (this.mapSubscribe) {
      this.mapSubscribe.unsubscribe();
    }
  }

  whenMapReady(): void {

    if (!this.point) {
      this.point = this.o.getMap(this.map).getCenter();
    }

    let data = Object.assign([], this.data)
      .map(x => Object.assign([], this.angles[x]))
      .sort((a, b) => a[0] - b[0]);

    let i = 0;
    let length = data.length;

    while (i < length) {

      if (!data[i] || !data[i + 1]) { break; }

      // debugger;

      if (OsmSemicircleCombinedComponent.eq(data[i][1], data[i + 1][0]))
      {
        data[i][1] = data[i + 1][1];
        data.splice(i + 1, 1);
        length = data.length;
        i > 0 ? i-- : i;
        continue;
      }

      if (OsmSemicircleCombinedComponent.eq(data[i][0], data[i + 1][1]))
      {
        data[i][0] = data[i + 1][0];
        data.splice(i + 1, 1);
        length = data.length;
        i > 0 ? i-- : i;
        continue;
      }

      data.sort((a, b) => a[0] - b[0]);

      i++;
    }

    if (data.length === 1 && data[0][0] > data[0][1]) {
      data[0][0] -= 365;
    }

    this.semicircle = data;
  }

}
